import { useDispatch, useSelector } from "react-redux";
import React, { CSSProperties } from "react";
import Switch from "common/Buttons/Switch";
import styled, { useTheme } from "styled-components";
import { selectIsDarkMode } from "@shared/slices/common.slice";
import MoonFilled from "@ant-design/icons/MoonFilled";
import SunFilled from "@ant-design/icons/SunFilled";
import Flex from "common/Boxes/Flex.tsx";
import Text from "common/Typography/Text.tsx";
import Tag from "common/Tags/Tag.tsx";
import { themeUpdated } from "services/webview/webViewBridgeUtils.ts";
import { sharedLib } from "@shared/services/shared.service.ts";

interface DarkModeToggleProps {
  textStyle?: CSSProperties;
}

const DarkModeToggle = ({ textStyle }: DarkModeToggleProps) => {
  const dispatch = useDispatch();
  const isDarkMode = useSelector(selectIsDarkMode);
  const appTheme = useTheme();

  const handleToggleDarkMode = () => {
    const updatedIsDarkMode = !isDarkMode;
    dispatch(sharedLib.slices.common.actions.setIsDarkMode(updatedIsDarkMode));
    themeUpdated(updatedIsDarkMode).catch(() => {});
  };

  return (
    <Flex style={{ width: "100%" }}>
      <Flex>
        <Text style={textStyle}>Dark Mode</Text>
        <Tag
          color={appTheme.colors.cardBgColor}
          bgColor={appTheme.colors.primaryBlue}
          style={{ marginLeft: 8 }}
        >
          NEW
        </Tag>
      </Flex>
      <StyledSwitch
        checked={isDarkMode}
        checkedChildren={
          <SunFilled style={{ color: appTheme.colors.buttonText }} />
        }
        onClick={handleToggleDarkMode}
        unCheckedChildren={
          <MoonFilled style={{ color: appTheme.colors.buttonText }} />
        }
      />
    </Flex>
  );
};

export default DarkModeToggle;

const StyledSwitch = styled(Switch)`
  .ant-switch-inner-checked {
    i::before {
      background-color: transparent !important;
    }
  }
`;
